export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10458.5f8f571f.jpg";